export default __webpack_public_path__ + "static/media/backgroundArc.6fc32f30.svg";